import React, { Fragment, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { Box, Hide } from '@qga/roo-ui/components';
import { getIsLoading } from 'store/search/searchSelectors';
import MapStateIndicator from 'components/MapSearchPage/MapStateIndicator';
import GoogleMap from 'components/maps/GoogleMap';
import FixedSearchControls from 'components/FixedSearchControls';

const FixedPositionWrapper = styled(Box)`
  position: absolute;
  width: 100%;
  height: 0px;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  overflow: visible;
`;

const GoogleMapWithUI = ({ onUpdateQuery, onMapAPILoaded, onTouchSearchUpdated, children, ...props }) => {
  const [mapReady, setMapReady] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const isLoading = useSelector(getIsLoading);

  const handleMapMoved = useCallback(() => {
    if (mapReady) {
      setIsDirty(true);
    }
  }, [mapReady, setIsDirty]);

  const handleRequeryMap = useCallback(() => {
    setIsDirty(false);
    onUpdateQuery();
  }, [setIsDirty, onUpdateQuery]);

  const onUpdatePolygon = (polygon) => {
    onTouchSearchUpdated(polygon);
  };

  return (
    <Fragment>
      <GoogleMap
        onMapAPILoaded={onMapAPILoaded}
        onMapTilesLoaded={setMapReady}
        onMapMoved={handleMapMoved}
        onUpdatePolygon={onUpdatePolygon}
        ready={mapReady}
        isDirty={isDirty}
        {...props}
      >
        {children}
      </GoogleMap>
      {mapReady && (
        <>
          <FixedPositionWrapper bottom={[70, 5]}>
            <MapStateIndicator isMapBoundsDirty={isDirty} isLoading={isLoading} onClick={handleRequeryMap} />
            <Hide md lg>
              <FixedSearchControls isMapSearch />
            </Hide>
          </FixedPositionWrapper>
        </>
      )}
    </Fragment>
  );
};

GoogleMapWithUI.propTypes = {
  onUpdateQuery: PropTypes.func,
  onMapAPILoaded: PropTypes.func,
  onTouchSearchUpdated: PropTypes.func,
  children: PropTypes.node,
};

GoogleMapWithUI.defaultProps = {
  onUpdateQuery: () => {},
  onMapAPILoaded: () => {},
  onTouchSearchUpdated: () => {},
  children: null,
};

export default GoogleMapWithUI;
